import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  background?: string;
  color?: string;
};

const AvatarSeven: FC<Props> = ({
  background = colors['--slate'],
  color = colors['--body'],
}) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ background, borderRadius: '9px' }}
  >
    <path
      d="M13.329 22.1192C13.329 22.5485 12.9605 22.8965 12.5059 22.8965H11.9297C11.4751 22.8965 11.1066 23.2445 11.1066 23.6738L11.1679 25.4573C11.1679 25.8866 11.5364 26.2346 11.991 26.2346H12.6495C13.104 26.2346 13.4725 25.8866 13.4725 25.4573L13.4113 23.6738C13.4113 23.2445 13.7798 22.8965 14.2343 22.8965H18.3943V20.7201H14.152C13.6974 20.7201 13.329 21.0681 13.329 21.4974V22.1192Z"
      fill={color}
    />
    <path
      d="M14.6887 22.8425V20.6661H17.8479C18.3025 20.6661 18.671 21.0141 18.671 21.4434V22.0652C18.671 22.4945 19.0395 22.8425 19.4941 22.8425H20.0703C20.5248 22.8425 20.8933 23.1906 20.8933 23.6199L20.9546 25.4033C20.9546 25.8326 20.5861 26.1806 20.1315 26.1806H19.4731C19.0185 26.1806 18.65 25.8326 18.65 25.4033L18.5887 23.6199C18.5887 23.1906 18.2202 22.8425 17.7656 22.8425H14.6887Z"
      fill={color}
    />
    <path
      d="M21.7777 19.5223C21.7777 19.0931 22.1462 18.745 22.6008 18.745H23.1769C23.6315 18.745 24 18.397 24 17.9677L24 14.2206C24 13.7913 23.6315 13.4433 23.1769 13.4433H22.5185C22.0639 13.4433 21.6954 13.7913 21.6954 14.2206L21.6954 17.9677C21.6954 18.397 21.3269 18.745 20.8723 18.745H11.9905V20.9215H20.9546C21.4092 20.9215 21.7777 20.5735 21.7777 20.1442V19.5223Z"
      fill={color}
    />
    <path
      d="M18.9265 18.745V20.9215H11.0454C10.5908 20.9215 10.2223 20.5735 10.2223 20.1442V19.5223C10.2223 19.0931 9.85381 18.745 9.39924 18.745H8.82308C8.36851 18.745 8 18.397 8 17.9677L8.00001 14.2206C8.00001 13.7913 8.36851 13.4433 8.82309 13.4433H9.48156C9.93613 13.4433 10.3046 13.7913 10.3046 14.2206L10.3046 17.9677C10.3046 18.397 10.6731 18.745 11.1277 18.745H18.9265Z"
      fill={color}
    />
    <path
      d="M21.7777 11.3561C21.7777 11.7854 22.1462 12.1334 22.6008 12.1334H23.1769C23.6315 12.1334 24 12.4814 24 12.9107L24 16.6578C24 17.0871 23.6315 17.4351 23.1769 17.4351H22.5184C22.0639 17.4351 21.6954 17.0871 21.6954 16.6578L21.6954 12.9107C21.6954 12.4814 21.3269 12.1334 20.8723 12.1334L11.9905 12.1334V9.9569L20.9546 9.9569C21.4092 9.9569 21.7777 10.3049 21.7777 10.7342V11.3561Z"
      fill={color}
    />
    <path
      d="M18.9265 12.1334V9.9569L11.0454 9.9569C10.5908 9.9569 10.2223 10.3049 10.2223 10.7342V11.3561C10.2223 11.7854 9.85382 12.1334 9.39925 12.1334H8.82309C8.36851 12.1334 8.00001 12.4814 8.00001 12.9107L8 16.6578C8 17.0871 8.36851 17.4351 8.82308 17.4351H9.48155C9.93612 17.4351 10.3046 17.0871 10.3046 16.6578L10.3046 12.9107C10.3046 12.4814 10.6731 12.1334 11.1277 12.1334L18.9265 12.1334Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7118 15.5665C11.7118 15.9958 12.0803 16.3438 12.5349 16.3438H13.1933C13.6479 16.3438 14.0164 15.9958 14.0164 15.5665V14.9058C14.0164 14.4765 13.6479 14.1285 13.1933 14.1285H12.5349C12.0803 14.1285 11.7118 14.4765 11.7118 14.9058V15.5665Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9836 15.5665C17.9836 15.9958 18.3521 16.3438 18.8066 16.3438H19.4651C19.9197 16.3438 20.2882 15.9958 20.2882 15.5665V14.9058C20.2882 14.4765 19.9197 14.1285 19.4651 14.1285H18.8066C18.3521 14.1285 17.9836 14.4765 17.9836 14.9058V15.5665Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8477 17.1387C14.8477 17.568 15.2162 17.916 15.6708 17.916H16.3292C16.7838 17.916 17.1523 17.568 17.1523 17.1387V16.478C17.1523 16.0487 16.7838 15.7007 16.3292 15.7007H15.6708C15.2162 15.7007 14.8477 16.0487 14.8477 16.478V17.1387Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5385 6.23462C11.993 6.23462 12.3615 6.58263 12.3615 7.01193V7.28398C12.3615 7.71328 12.73 8.06129 13.1846 8.06129H13.7608C14.2153 8.06129 14.5839 8.4093 14.5839 8.8386L14.6341 9.46321C14.6341 9.89251 15.0026 10.2405 15.4572 10.2405C15.9117 10.2405 16.2802 10.5885 16.2802 11.0178L16.1521 10.6012C16.1521 11.0305 15.7836 11.3785 15.3291 11.3785H11.3783C10.9237 11.3785 10.5552 11.0305 10.5552 10.6012L10.6833 11.0178C10.6833 10.5885 11.0518 10.2405 11.5064 10.2405C11.961 10.2405 12.3295 9.89251 12.3295 9.46321L12.2792 9.18839C12.2792 8.75909 11.9107 8.41108 11.4562 8.41108L9.48076 8.41108C9.02619 8.41108 8.65768 8.06307 8.65768 7.63377V7.01193C8.65768 6.58263 9.02619 6.23462 9.48076 6.23462L11.5385 6.23462Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9911 6.23462C19.5365 6.23462 19.168 6.58263 19.168 7.01193V7.28398C19.168 7.71328 18.7995 8.06129 18.3449 8.06129H17.7687C17.3142 8.06129 16.9457 8.4093 16.9457 8.8386L16.9959 9.46321C16.9959 9.89251 16.6274 10.2405 16.1728 10.2405C15.7182 10.2405 15.3497 10.5885 15.3497 11.0178L15.4778 10.6012C15.4778 11.0305 15.8463 11.3785 16.3009 11.3785H20.2517C20.7063 11.3785 21.0748 11.0305 21.0748 10.6012L20.9467 11.0178C20.9467 10.5885 20.5782 10.2405 20.1236 10.2405C19.669 10.2405 19.3005 9.89251 19.3005 9.46321L19.2503 9.18839C19.2503 8.75909 19.6188 8.41108 20.0734 8.41108L22.0488 8.41108C22.5033 8.41108 22.8718 8.06307 22.8718 7.63377V7.01193C22.8718 6.58263 22.5033 6.23462 22.0488 6.23462L19.9911 6.23462Z"
      fill={color}
    />
  </svg>
);

export default AvatarSeven;
